import { Injectable, inject } from '@angular/core';

import { OnFeatureInit } from '@frontend/vanilla/core';
import { LoginService } from '@frontend/vanilla/shared/login';

import { AffordabilityService } from './affordability.service';

@Injectable()
export class AffordabilityBootstrapService implements OnFeatureInit {
    private affordabilityService = inject(AffordabilityService);
    private loginService = inject(LoginService);

    onFeatureInit() {
        this.loginService.runAfterLogin(AffordabilityBootstrapService.name, () => this.affordabilityService.load());
    }
}
